import server from "@config/server";

class ReportService {
  static async generateReports(requestData) {
    const res = await server.post(`/report`, requestData);
    const data = res.data;
    return data;
  }
  static async dumpSligro() {
    const requestData = {
      type: "sligroSku",
    };
    const res = await server.post(`/report/dump`, requestData);
    const data = res.data;
    return data;
  }
}

export default ReportService;
